export default function Icon({ size = 16, icon, ...props }) {
    return (
        <svg
            width={size}
            height={size}
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            {...props}
        >
            <use xlinkHref={"/img/feather-sprite.svg#" + icon} />
        </svg>
    );
};

export function RequiredIcon () {
    return (<i className="text-danger">*</i>);
}